export const en = {
  tag: "en-US",
  page: {
    select: {
      title: "Select your store:",
    },
    status: {
      onMaintence: "Store under maintence...",
    },
    store: {
      tip: {
        part1: "Need help with your purchase? Contact us by ",
        partSocial: "Facebook",
        part2: " or ",
        partSystem: "Support",
      },
      item: {
        only: "Only",
        days: "day(s)",
        hours: "h",
        minutes: "min",
        seconds: "s",
        availableUntil: "Available until",
        buy: "BUY",
        gift: "Gift(s):",
        bonus: "Bonus Content:",
      },
      historic: "View history",
    },
    payment: {
      confirmationQuestion:
        "Are you sure you want to purchase for @Acc account and @Server server?",
      packsQuestion: "How many packs do you want?",
      methodQuestion: "Select the payment method:",
      other: "Other",
      note: "The final cost of the virtual goods may charge rates depending on the payment method selected. To see the final cost, click the button for the payment method you want.",
      noMethods: "No payment methods available in this moment. Please contact support for assistance.",
    },
    confirmation: {
      phone: "Enter phone number",
      fullname: "Enter fullname",
      cep: "Enter CEP",
      cpf: "Enter CPF",
      submit: "Submit",
      error: {
        phone: "Invalid phone number",
        fullname: "Incomplete fullname",
        invalidCep: "Invalid CEP",
        incompleteCep: "Incomplete CEP",
        incompleteCpf: "Incomplete CPF",
        invalidCpf: "Invalid CPF",
        submitMissingFields: "Error submitting missing fields",
      },
    },
  },
  component: {
    header: {
      button: "Back",
    },
    steps: {
      step1: "Store",
      step2: "Pack",
      step3: "Payment",
      step4: "Processing",
    },
    shop: {
      loading: "Loading store...",
      tabs: { evento: "EVENT", loja: "STORE", loki: "SEASON" },
      balance: "Current balance",
      history: "Purchase history",
      goToPayment: "GO TO PAYMENT",
      selectPackage: "SELECT A PACKAGE",
      cart: {
        empty: "Empty cart",
        items: "item(s) in cart",
        add: "Add items to continue.",
        total: "Total:",
        itemAdded: "Item added",
        itemRemoved: "Item removed",
      },
    },
    loyaltyPath: {
      title: "Loyalty Path",
      description: "Earn points by purchasing packs and redeem rewards.",
      learnMore: "Learn more",
      learnMoreTooltip: "For more information, access the link below.",
      learnMoreTooltipLink: "Click here to learn more",
      weekly: "WEEKLY JOURNEY",
      monthly: "MONTHLY JOURNEY",
      endsOn: "Ends in",
      totalPoints: "Total points earned:",
      points: "pts",
      available: "Available",
      claim: "Claim",
      claimed: "Claimed",
      inProgress: "In progress",
      period: "Period:",
      periodConnector: "to",
      accumulatedPoints: "Accumulated Points",
      currentPointsLabel: "Current score",
      projectedPointsLabel: "Projected score",
      faltam: "Missing",
      missingPoints: "points to next treasure",
      requirement: "Required:",
      scrollHint: "Drag to see all treasures →",
      blocked: "Locked",
      claimAgain: "Claim again",
      claimedTimes: "Claimed x{n}",
      timesClaimedLabel: "Times claimed: {n}",
      repeatable: "Renewable",
      repeatableTitle: "Unlimited claims",
      repeatableHint: "Claim again every time you reach the goal",
      repeatableCost: "Each claim costs {n} pts",
      balance: "Available balance",
      consumed: "Spent",
      carryoverReceived: "Unused points from previous edition",
      carryoverNextFull: "Unused points will be transferred to the next monthly edition.",
      carryoverNextPartial: "{pct}% of unused points will be transferred to the next monthly edition.",
      itemTypes: {
        movel: "Tradable",
        imovel: "Non-tradable",
        naoarmazenavel: "Non-storable",
        trocaunica: "Single trade",
      },
      claimModal: {
        successTitle: "Success!",
        successSingle: "You claimed {item}!",
        successMulti: "You claimed the items above!",
        errorTitle: "Attention",
        close: "Close",
        errors: {
          notFound: "Reward not found.",
          alreadyClaimed: "This reward has already been claimed.",
          editionClosed: "The edition has ended. Your points have been transferred to the next edition.",
          accountBlocked: "Your account is blocked for this action.",
          insufficientPoints: "Unable to claim. Check if previous goals were claimed or if you have enough points.",
          unknown: "An unexpected error occurred. If the problem persists, please contact support.",
        },
      },
    },
    packCard: {
      badge: "Pack",
      preSale: "PRE-SALE",
      bonusContent: "Bonus Content",
      packContent: "Pack Content",
      bonusContentTooltip: "Bonus content items will be delivered whenever a pack is purchased.",
      bonusContentTooltipLink: "Click here for more details",
      guaranteedGift: "[+] Guaranteed Gift!",
      guaranteedGiftTooltip:"The gift items will be guaranteed to be delivered exclusively to the first purchase of each package.",
      addToCart: "Add",
    },
    eventItems: {
      bannerTitle: "WEEKLY GIFT ACTIVATED",
      bannerText: "Purchase any available pack and receive an exclusive gift!",
      bannerTooltip: "The Outfit and the Pass are monthly single-redemption items. Once redeemed, they will no longer be sent that month.",
    },
    cart: {
      title: "Your Cart",
      empty: "Your cart is empty.",
      summaryTitle: "Items you will receive",
      serverGlobal: "Global",
      serverSeason: "Season",
      summarySubtext: "By completing this cart's purchase, you will receive the following items in your account:",
      noGiftsEmpty: "Add event packs to see gifts here.",
      noGiftsPacks: "The selected packs have no additional gifts.",
      continueShopping: "Continue shopping",
      resumo: "TOTAL AND PAYMENT",
      products: "product",
      productsPlural: "products",
      finalize: "Checkout",
      finalizeDisabled: "CHOOSE PAYMENT METHOD",
      paymentNote: "The final payment cost may change depending on the method chosen. To see the final cost, click the buttons above.",
      cardRestrictedNote: "Card payment isn't available for your profile above $100. Use Pix to continue.",
      paymentHints: {
        "picpay-pix": "Get your purchase approved faster with Pix",
        "picpay": "Download the PicPay app and pay in up to 12 interest-free installments",
      },
    },
    loyaltyHistory: {
      title: "Loyalty Pass - History",
      date: "Date",
      pack: "Pack",
      pointsEarnedMonthly: "Points earned monthly",
      pointsEarnedWeekly: "Points earned weekly",
    },
    purchaseHistory: {
      title: "Purchase History",
      date: "Date",
      pack: "Pack",
      price: "Price",
      qty: "Qty",
      gateway: "Gateway",
      status: "Status",
      server: "Server",
      empty: "No purchases found.",
      statusLabels: {
        waiting: "Waiting",
        processing: "Processing",
        delivered: "Delivered",
      },
    },
  },
};
